<script lang="ts">
	import { Tooltip as TooltipPrimitive } from "bits-ui";
	import { getContext } from "svelte";
	import { cn } from "$lib/utils.js";
	import { TOOLTIP_PORTAL_DISABLED_CONTEXT } from "./portal-context.js";

	let {
		ref = $bindable(null),
		class: className,
		sideOffset = 0,
		side = "top",
		children,
		arrowClasses,
		...restProps
	}: TooltipPrimitive.ContentProps & {
		arrowClasses?: string;
	} = $props();

	// An ancestor (e.g. the splash showcase's 3D-rotated wrapper) can opt out
	// of portalling so tooltip content renders inline next to its trigger and
	// inherits the parent's CSS transform. By default, content still portals
	// to document.body — preserving existing behaviour everywhere else.
	const portalDisabled = getContext<boolean>(TOOLTIP_PORTAL_DISABLED_CONTEXT) === true;
</script>

<TooltipPrimitive.Portal disabled={portalDisabled}>
	<TooltipPrimitive.Content
		bind:ref
		data-slot="tooltip-content"
		{sideOffset}
		{side}
		class={cn(
			"bg-primary text-primary-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-(--bits-tooltip-content-transform-origin) z-50 w-fit text-balance rounded-md px-3 py-1.5 text-xs",
			className
		)}
		{...restProps}
	>
		{@render children?.()}
		<TooltipPrimitive.Arrow>
			{#snippet child({ props })}
				<div
					class={cn(
						"bg-primary z-50 size-2.5 rotate-45 rounded-[2px]",
						side === "top" && "translate-x-1/2 translate-y-[calc(-50%_+_2px)]",
						side === "bottom" && "-translate-x-1/2 -translate-y-[calc(-50%_+_1px)]",
						side === "right" && "translate-x-[calc(50%_+_2px)] translate-y-1/2",
						side === "left" && "-translate-y-[calc(50%_-_3px)]",
						arrowClasses
					)}
					{...props}
				></div>
			{/snippet}
		</TooltipPrimitive.Arrow>
	</TooltipPrimitive.Content>
</TooltipPrimitive.Portal>
